'use client';

import { theme } from '@prose-ui';

import { TextImage } from 'Components/TextImage';

import desktopImage from 'assets/images/reviews/d-reviews-hero.jpg';
import mobileImage from 'assets/images/reviews/m-reviews-hero.jpg';

export const IntroReviews = () => (
  <TextImage
    backgroundColor={theme.colors.neutral['900']}
    contentAlign="left"
    contentAlignMob="left"
    dataTestId="reviews-intro-block"
    description="With Review & Refine®, our one-of-a-kind feedback tool, we gather real customer reviews to deliver always-improving formulas, an always-custom fit, and lasting, transformative results. Your feedback is essential."
    descriptionProps={{ color: 'white' }}
    disclaimer="*Product reviews via Review & Refine®"
    imageAlt="image alt"
    imageDesktop={desktopImage}
    imageMobile={mobileImage}
    imageMode="cover"
    subtitle="Prose reviews + ratings"
    subtitleProps={{ style: { fontSize: 14 }, color: 'white' }}
    title={
      <>
        Custom beauty with 500K+ <br /> 5-star reviews*
      </>
    }
    titleProps={{ variant: 'h1r', color: 'white', markupName: 'h1' }}
    wideScreenOrder="21"
  />
);
